import { awsApiInstance } from '../../api/aws-api';
import useAuth from '../../hooks/auth-hooks';

import { IGenericPostResponse } from '../../models/generic.interface'; // Assuming a more generic interface
import { handleRouteError } from './route-error';

/**
 * Generic function to make POST requests
 * 
 * @param {string} endpoint - The API endpoint to post data to
 * @param {Object} modelData - The data to be posted
 * @param {string} errorMessage - Custom error message for handling errors
 * 
 * @returns {IGenericPostResponse} - The API response or error
 */
const PostToApi = async (endpoint: string, modelData: Object, errorMessage: string): Promise<IGenericPostResponse> => {
  try {
    const { userId } = useAuth()!;

    const requestData = { wpId: userId, ...modelData };

    const { data } = await awsApiInstance.post(endpoint, requestData);

    return data;
  } catch (error) {
    handleRouteError(error, errorMessage);
    throw(error);
  }
}

export default PostToApi;